<mibi-box-layout>
    <article class="mibi-datenschutzhinweise">
        <h3 class="mibi-datenschutzhinweise-item-header">
            Wer ist für die Datenverarbeitung verantwortlich, und an wen kann ich mich wenden?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Verantwortliche Stelle
                ist:
            </p>
            <table>
                <tbody>
                    <tr>
                        Bundesinstitut für Risikobewertung (BfR)
                    </tr>
                    <tr>
                        Fachgruppe 43
                    </tr>
                    <tr>Max-Dohrn-Str. 8-10</tr>
                    <tr>10589 Berlin</tr>
                    <tr>Tel.: 030-18412-0</tr>
                    <tr>E-Mail: <a href="mailto:mibi-portal@bfr.bund.de">mibi-portal&#64;bfr.bund.de</a></tr>
                    <tr><a href="https://www.bfr.bund.de" target="_blank" rel="noopener">www.bfr.bund.de</a></tr>
                </tbody>
            </table>
            <br>
            <p *ngIf="dataProtectionOfficerIdCard.gender === 'male'">
                Unser Datenschutzbeauftragter ist:
            </p>
            <p *ngIf="dataProtectionOfficerIdCard.gender === 'female'">
                Unsere Datenschutzbeauftragte ist:
            </p>
            <table>
                <tbody>
                    <tr>{{dataProtectionOfficerIdCard.prefix}} {{dataProtectionOfficerIdCard.name}}</tr>
                    <tr *ngFor="let info of dataProtectionOfficerIdCard.infos">{{info}}</tr>
                    <tr>E-Mail: <a [href]="'mailto:' + dataProtectionOfficerIdCard.email">{{dataProtectionOfficerIdCard.email}}</a></tr>
                </tbody>
            </table>
        </div>
        <h3 class="mibi-datenschutzhinweise-item-header">
            Welche Quellen und Daten nutzen wir?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Wir verarbeiten Daten, die wir im Rahmen Ihrer Anmeldung von Ihnen erhalten.
            </p>

            <p>
                Es werden folgende Daten bei der Online-Registrierung verarbeitet:
            </p>
            <ul class="mibi-datenschutzhinweise-list">
                <li>Institution*</li>
                <li>Name*</li>
                <li>Vorname*</li>
                <li>E-Mail-Adresse*</li>
            </ul>
            <div><em>* Pflichtfelder</em></div>
            <br>
            <p>
                Zudem werden bei Aufruf unserer Seiten von Ihrem Webbrowser automatisch technische
                Informationen an
                uns
                übermittelt. Dabei handelt es sich zum Beispiel um:
            </p>
            <ul class="mibi-datenschutzhinweise-list">
                <li>Browsertyp und -version</li>
                <li>verwendetes Betriebssystem</li>
                <li>Website, von der aus Sie uns besuchen (Referrer URL)</li>
                <li>Datum und Uhrzeit Ihres Zugriffs (wird anonymisiert geloggt)</li>
                <li>Ihre Internet Protokoll (IP)-Adresse</li>
            </ul>
            <p>
                Eine Zusammenführung dieser Daten mit Daten aus Ihrer Online-Registrierung ist uns nicht
                möglich.
            </p>
            <p>
                Bitte beachten Sie auch unsere <a href=" https://www.bfr.bund.de/datenschutz/"
                    target="_blank" rel="noopener">allgemeinen
                    Datenschutzbestimmungen</a> unter <a href="https://www.bfr.bund.de" target="_blank"
                    rel="noopener">www.bfr.bund.de</a>.
            </p>
        </div>


        <h3 class="mibi-datenschutzhinweise-item-header">
            Wofür verarbeiten wir Ihre Daten (Zweck der Verarbeitung) und auf welcher Rechtsgrundlage?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Wir verarbeiten Ihre personenbezogenen Daten im Einklang mit den Bestimmungen der
                Datenschutz-Grundverordnung (DS-GVO) und dem Bundesdatenschutzgesetz (BDSG-neu).
            </p>
            <p>
                Zweck des Zoonosen-Monitorings:
            </p>
            <p>
                §1 der Allgemeine Verwaltungsvorschrift über die Erfassung, Auswertung und Veröffentlichung
                von
                Daten
                über das Auftreten von Zoonosen und Zoonose-Erregern entlang der Lebensmittelkette (AVV
                Zoonosen
                Lebensmittelkette):
            </p>
            <p>
                Diese allgemeine Verwaltungsvorschrift dient der bundesweit einheitlichen Durchführung der
                Beobachtung
                von Zoonosen und Zoonose-Erregern (Zoonosen-Monitoring) gemäß den Bestimmungen der
                Richtlinie
                2003/99/EG des Europäischen Parlaments und des Rates vom 17. November 2003 zur Überwachung
                von
                Zoonosen
                und Zoonose-Erregern und zur Änderung der Entscheidung 90/424/EWG des Rates sowie zur
                Aufhebung
                der
                Richtlinie 92/117/EWG des Rates (ABl. L 325 vom 12.12.2003, S. 31) in der jeweils geltenden
                Fassung.
                Das Zoonosen-Monitoring nach Satz 1 umfasst die Erfassung, Auswertung, Übermittlung und
                Veröffentlichung repräsentativer Daten über das Auftreten von:
            </p>
            <ul class="mibi-datenschutzhinweise-list">
                <li>Zoonose-Erregern in Futtermitteln und Lebensmitteln, auch durch Probenahme an Einrichtungen und
                    Ausrüstungsgegenständen von Lebensmittelunternehmen,</li>
                <li>Zoonosen und Zoonose-Erregern bei lebenden Tieren nach § 4 Absatz 1 Nummer 1 des Lebensmittel-
                    und
                    Futtermittelgesetzbuches,</li>
                <li>Antibiotikaresistenzen bei
                    <ul class="mibi-datenschutzhinweise-list">
                        <li>Zoonose-Erregern und</li>
                        <li> anderen Bakterien, die die öffentliche Gesundheit gefährden oder zu einem Eintrag von
                            Antibiotikaresistenzen in die Lebensmittelkette führen können.</li>
                    </ul>
                </li>
            </ul>

            <p>
                Konkreter Zweck der Verarbeitung der personenbezogenen Daten ist es, sicherzustellen, dass
                der
                angemeldete Benutzer berechtigt ist
            </p>
            <ul class="mibi-datenschutzhinweise-list">
                <li>Daten mit Bezug zu einer konkreten einsendenden Untersuchungseinrichtung an das BfR
                    zu
                    senden</li>
                <li>
                    vom BfR bereitgestellte Daten einsehen zu dürfen.
                </li>
            </ul>

            <p>
                Rechtsgrundlage für die Verarbeitung Ihrer personenbezogenen Daten ist Art. 6 I e DS-GVO in
                Verbindung
                mit den Rechtsgrundlagen für die Übermittlung der Probendaten für das Zoonosen-Monitoring.

                Diese wird gebildet von:
            </p>
            <ol class="mibi-datenschutzhinweise-list">
                <li>Art. 4, 5, 7, und 9 der RL 2003/99/EG</li>
                <li>Vorschriften des BfR-Gesetzes (BfRG):
                    <ul class="mibi-datenschutzhinweise-list">
                        <li>§ 2 Abs.1 Nr. 10, 11 BfRG [Wahrnehmung der Funktion von 17 nationalen
                            Referenzlaboratorien]</li>
                        <li>§ 2 Abs. 1 Nr. 1 BfRG [Erstellung von wissenschaftlichen Stellungnahmen zur
                            Lebensmittelsicherheit und zum Verbraucherschutz im Hinblick auf die Gesundheit
                            des
                            Menschen]</li>
                        <li>§ 2 Abs. 1 Nr. 2 BfRG [Wissenschaftliche Beratung der Bundesministerien sowie
                            des
                            Bundesamtes für Verbraucherschutz und Lebensmittelsicherheit (BVL)]</li>
                        <li>§ 2 Abs. 1 Nr. 3 BfRG [Zusammenarbeit auf nationaler, europäischer und
                            internationaler Ebene, insbesondere mit der Europäischen Behörde für
                            Lebensmittelsicherheit, sowie Koordination des wissenschaftlichen
                            Informationsaustauschs auf dem Gebiet der Lebensmittelsicherheit und des
                            Verbraucherschutzes]</li>
                    </ul>
                </li>
            </ol>


        </div>


        <h3 class="mibi-datenschutzhinweise-item-header">
            Wer bekommt meine Daten?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Ihre persönlichen Daten (Institution, Name, Vorname, E-Mail-Adresse) werden zusammen
                mit
                dem
                hochgeladenen Untersuchungsauftrag an das zuständige Nationale Referenzlabor (NRL)
                weitergeleitet
                und dort
                in
                unserem Laborinformations- und Management-System (LIMS) verarbeitet.
            </p>
        </div>


        <h3 class="mibi-datenschutzhinweise-item-header">
            Sicherheitsmaßnahmen und Übermittlung
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Durch technische und organisatorische Maßnahmen stellen wir sicher, dass Ihre
                persönlichen und
                Isolat-Daten gegen zufällige oder vorsätzliche Manipulation und unberechtigte
                Zugriffe
                geschützt
                sind.
                Die Übertragung Ihrer Online-Registrierung erfolgt daher verschlüsselt nach dem
                aktuell
                anerkannten
                Stand der Technik.
            </p>
            <p>
                Die Verarbeitung Ihrer Daten findet ausschließlich in Deutschland statt.
            </p>
        </div>


        <h3 class="mibi-datenschutzhinweise-item-header">
            Wie lange werden meine Daten gespeichert?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Ihre Anmeldedaten bleiben im Portal solange gespeichert, bis Sie eine Löschung
                beantragen. Der
                Antrag
                kann formlos via E-Mail an <a href="mailto:mibi-portal@bfr.bund.de">mibi-portal&#64;bfr.bund.de</a> erfolgen.

                Die Verarbeitung der eingesendeten Isolat-Daten im zuständigen NRL unterliegt
                gesetzlichen
                Aufbewahrungsfristen. In diesem Zusammenhang bleiben bei einer Weiterleitung an
                das
                NRL auch Ihre
                personenbezogenen Daten im gesetzlichen Umfang im LIMS gespeichert.
            </p>
        </div>


        <h3 class="mibi-datenschutzhinweise-item-header">
            Welche Datenschutzrechte habe ich?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Jede betroffene Person hat das Recht auf Auskunft nach Art. 15 DS-GVO, das
                Recht auf Berichtigung
                nach
                Art. 16 DS-GVO, das Recht auf Löschung nach Art. 17 DS-GVO, das Recht auf
                Einschränkung der
                Verarbeitung nach Art. 18 DS-GVO, das Recht auf Widerspruch aus Art. 21
                DS-GVO
                sowie das Recht auf
                Datenübertragbarkeit aus Art. 20 DS-GVO. Beim Auskunftsrecht und beim
                Löschungsrecht gelten die
                Einschränkungen nach §§ 34 und 35 BDSG-neu. Darüber hinaus besteht ein
                Beschwerderecht bei einer
                Datenschutzaufsichtsbehörde gemäß Art. 77 DS-GVO i.V.m. § 19 BDSG.
            </p>
        </div>


        <h3 class="mibi-datenschutzhinweise-item-header">
            Gibt es für mich eine Pflicht zur Bereitstellung von Daten?
        </h3>
        <div class="mibi-datenschutzhinweise-item">
            <p>
                Nein, es gibt keine Pflicht zur Preisgabe personenbezogener Daten.
                Allerdings können einige
                Angebote
                des Portals ohne Registrierung nicht genutzt werden. So ist es z.B.
                nicht
                möglich, einen
                Untersuchungsauftrag
                über das Portal an das BfR zu senden, ohne sich angemeldet zu haben. Um
                den
                gesetzlichen Pflichten
                nachzukommen, müssen in diesem Falle die alternativen klassischen Wege
                der
                Datenübermittlung
                benutzt
                werden.
            </p>
        </div>


        <footer class="mibi-datenschutzhinweise-footer mat-small">
            <span>Fundstellen:</span>
            <div>
                <p>
                    DS-GVO: VERORDNUNG (EU) 2016/679 DES EUROPÄISCHEN PARLAMENTS UND DES
                    RATES vom 27. April 2016 zum
                    Schutz
                    natürlicher Personen bei der Verarbeitung personenbezogener Daten, zum
                    freien Datenverkehr und zur
                    Aufhebung
                    der Richtlinie 95/46/EG (Datenschutz-Grundverordnung), veröffentlicht
                    im Amtsblatt der Europäischen
                    Union
                    am
                    04.05.2016, deutsche Fassung, S. L 119/1 ff.
                    BDSG-neu: Gesetz zur Anpassung des Datenschutzrechts an die Verordnung
                    (EU) 2016/679 und zur Umsetzung
                    der
                    Richtlinie (EU) 2016/680 (Datenschutz-Anpassungs- und -Umsetzungsgesetz
                    EU - DS-AnpUG EU),
                    veröffentlicht
                    im
                    Bundesgesetzblatt Jahrgang 2017, Teil I Nr. 44, S. 2097 ff.
                </p>
            </div>
            <span>Stand: <time>24.06.2025</time></span>
        </footer>
    </article>
</mibi-box-layout>